/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 2 = BillFileUpload

3 = Plans

4 = TimeclockShift

5 = Specifications

6 = ChangeOrders

7 = Estimates

8 = AiSearch

9 = CostInboxMigration

10 = BillApproval

11 = MobileApp

12 = Tasks

13 = Submittals

14 = BillPartialPayments

15 = BillPayment

16 = SelectionAutofillFromUrl

17 = SelectionsCatalog

18 = Invoices

19 = ProgressInvoices

20 = SelectionInvoicingWizard

21 = CatalogSpecifications

22 = LienWaivers

23 = SelectionAutofillFromDocument

24 = TimeclockRNMobile

25 = Rfis

26 = SelectionsReimagined

27 = AutoFillInvoice

28 = AccountingSyncMoment

29 = BuilderBidsFeedback

30 = JobPriceSummary

31 = SelectionsTemplates

32 = DailyLogsRNMobile


 */
export type FeedbackTarget =
  (typeof FeedbackTarget)[keyof typeof FeedbackTarget];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackTarget = {
  BillFileUpload: 2,
  Plans: 3,
  TimeclockShift: 4,
  Specifications: 5,
  ChangeOrders: 6,
  Estimates: 7,
  AiSearch: 8,
  CostInboxMigration: 9,
  BillApproval: 10,
  MobileApp: 11,
  Tasks: 12,
  Submittals: 13,
  BillPartialPayments: 14,
  BillPayment: 15,
  SelectionAutofillFromUrl: 16,
  SelectionsCatalog: 17,
  Invoices: 18,
  ProgressInvoices: 19,
  SelectionInvoicingWizard: 20,
  CatalogSpecifications: 21,
  LienWaivers: 22,
  SelectionAutofillFromDocument: 23,
  TimeclockRNMobile: 24,
  Rfis: 25,
  SelectionsReimagined: 26,
  AutoFillInvoice: 27,
  AccountingSyncMoment: 28,
  BuilderBidsFeedback: 29,
  JobPriceSummary: 30,
  SelectionsTemplates: 31,
  DailyLogsRNMobile: 32,
} as const;
